export default "__VITE_ASSET__3G2px7$D__"